import { Page } from 'layouts/Page';
import { FC } from 'react';
import { GpsrService } from 'components/GpsrService';

export const GpsrServicePage: FC = () => {
	return (
		<Page title="GPSR Service – EAS Dashboard">
			<GpsrService />
		</Page>
	);
};
